var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `${_vm.prefix}-container`,
    _vm.mode === 'block' ? `${_vm.prefix}-block` : `${_vm.prefix}-text`,
    _vm.plain ? `${_vm.prefix}-plain` : '', 
    _vm.checked ? `${_vm.prefix}-checked` : ''
  ],style:(_vm.customStyle),on:{"click":_vm.handleTagClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }